// removed by extract-text-webpack-plugin
module.exports = {"container":"_3vpjpozjSu4Dr7odHH03D1","title":"_1rSBrbOEQvbR23ScfG8lWe","noTable":"_11-elFCyehzyoZ17Y7p6AT"};


//////////////////
// WEBPACK FOOTER
// ./src/App/Pages/Payment/Fail/styles.css
// module id = 3314
// module chunks = 0